import { render } from "./why-e4t-page.vue?vue&type=template&id=10969b77&ts=true"
import script from "./why-e4t-page.vue?vue&type=script&lang=ts"
export * from "./why-e4t-page.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__